import React from "react";
import { union } from "ramda";
import i18n from "../../i18n";
import styled, { withTheme } from "styled-components";
import { List, Row, Col } from "antd";
import { ArrayUtil, isFunction, isAlive, ColorUtil, MathUtil, isFillAlive } from "../../util";
import { Metrics, Colors } from "../../theme";
import { OHeader, TooltiptextBox } from "../text/OText";
import { ColorSquare } from "../button/ColorButton";
import { DataVisualizeKeys } from "../../theme/Colors";
import { InlineDiv, HoverableDiv } from "../layout/Layout";
import { IncrementText, IncrementTextType } from "../text/OText";

const ExamplePercentData = ArrayUtil.createLength(5, (index)=>({
	text:`value ${index}`,
	value: Math.abs(Math.sin(index*10)*5).toFixed(2), 
	percent: Math.abs(Math.sin(index*10)).toFixed(2)
}));

export const ValueP = styled.p`
    font-size:${Metrics.fontSize.content}px;
    text-align:right;
    padding-right:5px;
    min-width: ${props=>props.minWidth ? props.minWidth : 60}px;
`;
const ListItem = styled.div`
    display:flex;
    justify-content:space-between;
    width: 100%;
    padding: 12px 8px 12px 8px;
    border-bottom: ${props=>props.hasNext ? "1px solid #e8e8e8" : ""};
	${props=>props.clickable ? 
		`&:hover {
			background-color:${Colors.hoverBackgroundColor};
			cursor:pointer;
		}` 
		: ""}
`;
/**
 * Create new data array with percentage of the sum value
 * @param {array} datas 
 * @param {function} additionalMod
 */
export const makePercent = (datas, valueKey="value", additionalMod = undefined )=>{
	let sum = 0;
	datas.forEach(element=>{
		sum += element[valueKey];
	});
	return Array.from(datas.slice(),(element,index)=>{
		let out = {
			...element,
			percent: sum === 0 ? 0 : ((element[valueKey] / sum) * 100).toFixed(1)
		};
		if(isFunction(additionalMod)){
			out = additionalMod(out,index);
		}
		return out;
	});
};
const makeObject = (dataArray, getKey)=>{
	const out = {};
	dataArray.forEach(e=>{
		out[getKey(e)] = e;
	});
	return out;
};
const DataPercentList = ({
	header,
	percentDatas = ExamplePercentData,
	compareDatas = undefined,
	style = undefined,
	textKey="text",
	valueKey="value",
	percentKey="percent",
	showValue = true,
	showColor = false,
	theme = undefined,
	visualColorKey = DataVisualizeKeys.Primary,
	onClick,
})=>{
	if(!isFillAlive(percentDatas)){
		return <TooltiptextBox>
			{i18n.t("no_data")}
		</TooltiptextBox>;
		//<div>{i18n.t('no_data')}</div>
	}
	let colors = [];
	let colorOfItem = {};
	let combineDatas = percentDatas;

	const percentKeys = percentDatas.map(e=>e[textKey]);
	let combineKeys = percentKeys;
	let mutateDatas = {};
	const percentObj = makeObject(percentDatas, e=>e[textKey]);
	const clickable = isFunction(onClick);
	if(ArrayUtil.isAliveArray(compareDatas)){
		combineKeys = union(compareDatas.map(e=>e[textKey]), percentKeys);
		const compareObj = makeObject(compareDatas, e=>e[textKey]);
		combineKeys.forEach(key=>{
			let out;
			if(percentObj[key] === undefined){
				out = {
					...compareObj[key],
					[valueKey]:0,
					[percentKey]:"0",
					compare: -1,
				};
			}else if(compareObj[key] === undefined){
				out = {
					...percentObj[key],
					compare: 1,
				};
			}else{
				const compareVal = compareObj[key][valueKey];
				const value = percentObj[key][valueKey];
				out = {
					...percentObj[key],
					compare: MathUtil.increaseRatio(value, compareVal)
				};
			}
			mutateDatas[key] = out;
		});
	}else{
		mutateDatas = percentObj;
	}
	if(showColor){
		colors = ColorUtil.generateVisualColorOfSize(theme, visualColorKey, percentDatas.length);
		percentDatas.forEach((element,index) => {
			colorOfItem[element[textKey]] = colors[index];
		});
	}
	return (<div style={{...style}}>
		{header ? <OHeader>{header}</OHeader> : undefined}
		<div style={{overflowY:"auto"}}>
			{combineKeys.map((key,i)=>{
				const item = mutateDatas[key];
				let itemCompareType = IncrementTextType.EQUALS;
				if(item.compare > 0){
					itemCompareType = IncrementTextType.UP;
				}else if(item.compare < 0){
					itemCompareType = IncrementTextType.DOWN;
				}
				return (<ListItem 
					key={i} 
					clickable={clickable} 
					hasNext={i<combineKeys.length-1}
					onClick={onClick ? ()=>{onClick(item);} : undefined}>
					<div style={{maxWidth:showValue ? "50%" : "100%"}}>
						<InlineDiv middle>
							{item.icon}
							{showColor ? <ColorSquare style={{marginRight:Metrics.button.spaceMargin}} 
								color={colorOfItem[item[textKey]]} 
								size={12}
							/> : undefined}
							<div style={{
								overflow:"hidden",
								textOverflow:"ellipsis",
								whiteSpace:"nowrap"
							}}>{item[textKey]}</div>
						</InlineDiv>
					</div>
					{showValue ? <div style={{display:"flex"}}>
						{item.compare ? 
							<IncrementText 
								type={itemCompareType}
								value={`${(Math.abs(item.compare*100)).toFixed(2)}%`} 
							/> : undefined}
						<ValueP minWidth={40}>{item[valueKey]}</ValueP>
						<ValueP>{
							`${typeof item[percentKey] === "number" ? item[percentKey].toFixed(2) : item[percentKey]}%`
						}</ValueP>
					</div> : undefined}
				</ListItem>);
			})}
		</div>
	</div>);
};
export default withTheme(DataPercentList);


// WEBPACK FOOTER //
// ./src/components/list/DataPercentList.js